document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdPhotoModal");
  if (!modal) return;

  // ── Variant IDs ── TODO: Shopify-Varianten-IDs eintragen sobald Produkte erstellt
  // Format: { "Typ|Farbe": variantId }
  const BD_PHOTO_VARIANTS = {
    "essilor|Grau":               53757131784519,
    "essilor|Braun":              53757131817287,
    "essilor|Grün":               53757131850055,
    "essilor|Sapphire (Blau)":    53757131882823,
    "essilor|Amethyst (Violett)": 53757131915591,
    "essilor|Emerald (Grün)":     53757131948359,
    "essilor|Amber (Braun)":      53757131981127,
    "essilor|Ruby (Rot)":         53757132013895,
    "colormatic|Grau":            53757137453383,
    "colormatic|Braun":           53757137486151,
  };

  const stepType     = document.getElementById("bdPhotoStepType");
  const stepColor    = document.getElementById("bdPhotoStepColor");
  const stepRx       = document.getElementById("bdPhotoStepRx");
  const stepRxUpload = document.getElementById("bdPhotoStepRxUpload");

  const typeNext      = document.getElementById("bdPhotoTypeNext");
  const colorBack     = document.getElementById("bdPhotoColorBack");
  const colorNext     = document.getElementById("bdPhotoColorNext");
  const rxBack        = document.getElementById("bdPhotoRxBack");
  const rxNext        = document.getElementById("bdPhotoRxNext");
  const rxUploadBack  = document.getElementById("bdPhotoRxUploadBack");
  const rxUploadNext  = document.getElementById("bdPhotoRxUploadNext");

  const rxFile = document.getElementById("bdPhotoRxFile");

  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  let selectedType    = null;
  let selectedPrice   = null;
  let selectedName    = null;
  let selectedColor   = null;
  let selectedVariant = null;
  let isAdding        = false;
  let rxMethod        = null; // 'upload' | 'later'

  // Open trigger (delegated, works regardless of productForm)
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-photo-modal]")) {
      e.preventDefault();
      openModal();
    }
  });

  if (!productForm) return;

  // ── Helpers ────────────────────────────────────────────

  function hideAllSteps() {
    [stepType, stepColor, stepRx, stepRxUpload]
      .forEach(s => s && (s.style.display = "none"));
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    showStepType();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function showStepType() {
    hideAllSteps();
    if (stepType) stepType.style.display = "block";
    if (typeNext) typeNext.disabled = true;
    selectedType = null; selectedPrice = null; selectedName = null;
    selectedColor = null; selectedVariant = null;
    document.querySelectorAll(".bd-photo-typecard").forEach(c => c.classList.remove("is-selected"));
    document.querySelectorAll(".bd-photo-colorBtn").forEach(c => c.classList.remove("is-selected"));
    document.querySelectorAll('input[name="bdPhotoRxMethod"]').forEach(i => i.checked = false);
    if (rxFile) rxFile.value = "";
  }

  function showStepColor() {
    hideAllSteps();
    if (stepColor) stepColor.style.display = "block";
    if (colorNext) colorNext.disabled = true;
    selectedColor = null; selectedVariant = null;
    document.querySelectorAll(".bd-photo-colorBtn").forEach(c => c.classList.remove("is-selected"));

    const essilorGrid    = document.getElementById("bdPhotoEssilorColors");
    const colormaticGrid = document.getElementById("bdPhotoColormaticColors");
    const hint           = document.getElementById("bdPhotoColorHint");

    if (selectedType === "essilor") {
      if (essilorGrid)    essilorGrid.style.display    = "grid";
      if (colormaticGrid) colormaticGrid.style.display = "none";
      if (hint) hint.textContent = "8 Farbtöne – abgestimmt auf deinen Look.";
    } else {
      if (essilorGrid)    essilorGrid.style.display    = "none";
      if (colormaticGrid) colormaticGrid.style.display = "grid";
      if (hint) hint.textContent = "2 klassische Farbtöne.";
    }
  }

  function showStepRx() {
    hideAllSteps();
    if (stepRx) stepRx.style.display = "block";
    if (rxNext) rxNext.disabled = true;
    document.querySelectorAll('input[name="bdPhotoRxMethod"]').forEach(i => i.checked = false);
    if (rxFile) rxFile.value = "";
  }

  function showStepRxUpload() {
    hideAllSteps();
    if (stepRxUpload) stepRxUpload.style.display = "block";
    validateRxUpload();
  }

  function validateRxUpload() {
    if (rxUploadNext) rxUploadNext.disabled = !(rxFile?.files?.length);
  }

  async function parseCartError(res) {
    const text = await res.text();
    try {
      const json = JSON.parse(text);
      return json.description || json.message || text;
    } catch (_) {
      const match = text.match(/<title>(.*?)<\/title>/i);
      return match ? match[1] : "Unbekannter Fehler";
    }
  }

  async function addToCart(properties, fileInput) {
    if (isAdding) return;
    isAdding = true;

    try {
      const mainVariantId = productForm.querySelector('[name="id"]')?.value;
      if (!mainVariantId) throw new Error("Kein Variant ID gefunden.");

      const hasFile = fileInput && fileInput.files && fileInput.files.length;
      if (hasFile) {
        const fd = new FormData();
        fd.set("id", mainVariantId);
        fd.set("quantity", "1");
        Object.entries(properties).forEach(([k, v]) => fd.set(`properties[${k}]`, v));
        fd.set("properties[Sehtest Upload]", fileInput.files[0]);
        const res = await fetch("/cart/add", {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!res.ok) throw new Error(await parseCartError(res));
      } else {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: parseInt(mainVariantId), quantity: 1, properties }),
        });
        if (!res.ok) throw new Error(await parseCartError(res));
      }

      if (selectedVariant) {
        const resAddon = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({
            id: selectedVariant,
            quantity: 1,
            properties: {
              "Add-on für Variant":  String(mainVariantId),
              "Add-on für Produkt":  document.title || "Brille",
            },
          }),
        });
        if (!resAddon.ok) throw new Error(await parseCartError(resAddon));
      }

      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Fehler: " + (err && err.message ? err.message : String(err)));
      isAdding = false;
    }
  }

  // ── Close ──────────────────────────────────────────────

  modal.addEventListener("click", function (e) {
    if (e.target && e.target.hasAttribute("data-bd-photo-close")) closeModal();
  });

  // ── Step 1: Linsentyp ─────────────────────────────────

  document.querySelectorAll(".bd-photo-typecard").forEach(function (card) {
    card.addEventListener("click", function () {
      document.querySelectorAll(".bd-photo-typecard").forEach(c => c.classList.remove("is-selected"));
      card.classList.add("is-selected");
      selectedType  = card.getAttribute("data-photo-type");
      selectedPrice = card.getAttribute("data-photo-price");
      selectedName  = card.getAttribute("data-photo-name");
      if (typeNext) typeNext.disabled = false;
    });
  });

  if (typeNext) typeNext.addEventListener("click", function () {
    if (selectedType) showStepColor();
  });

  // ── Step 2: Farbe ─────────────────────────────────────

  if (colorBack) colorBack.addEventListener("click", showStepType);

  document.querySelectorAll(".bd-photo-colorBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".bd-photo-colorBtn").forEach(b => b.classList.remove("is-selected"));
      btn.classList.add("is-selected");
      selectedColor   = btn.getAttribute("data-photo-color");
      const key       = selectedType + "|" + selectedColor;
      selectedVariant = BD_PHOTO_VARIANTS[key] || null;
      if (colorNext) colorNext.disabled = false;
    });
  });

  if (colorNext) colorNext.addEventListener("click", function () {
    if (selectedColor) showStepRx();
  });

  // ── Step 3: Rx Methode ────────────────────────────────

  if (rxBack) rxBack.addEventListener("click", showStepColor);

  document.querySelectorAll('input[name="bdPhotoRxMethod"]').forEach(function (radio) {
    radio.addEventListener("change", function () {
      if (rxNext) rxNext.disabled = false;
    });
  });

  // Letzter Schritt (Sehstärke übermitteln) führt direkt in den Warenkorb —
  // PD wird hier nicht mehr erhoben; falls sie im eingereichten Sehtest fehlt,
  // wird der Kunde nach dem Kauf separat kontaktiert.
  function finalizeOrder() {
    const props = {
      "Gläserpaket":                selectedName,
      "Glasfarbe":                   selectedColor,
      "Gläserpaket Aufpreis (CHF)":  selectedPrice,
    };
    if (rxMethod === "upload") {
      props["Sehstärke übermittelt"] = "Sehtest Upload";
    } else {
      props["Sehstärke"] = "Wird später per E-Mail eingereicht";
    }
    closeModal();
    addToCart(props, rxMethod === "upload" ? rxFile : null);
  }

  if (rxNext) rxNext.addEventListener("click", function () {
    const method = document.querySelector('input[name="bdPhotoRxMethod"]:checked')?.value;
    rxMethod = method;
    if (method === "upload") showStepRxUpload();
    if (method === "later")  finalizeOrder();
  });

  // ── Step 4b: Upload ───────────────────────────────────

  if (rxUploadBack) rxUploadBack.addEventListener("click", showStepRx);
  rxFile?.addEventListener("change", validateRxUpload);

  if (rxUploadNext) rxUploadNext.addEventListener("click", function () {
    if (!rxFile?.files?.length) return;
    finalizeOrder();
  });
});
